// eslint-disable-next-line import/prefer-default-export
export const VARIANTS = ['primary', 'secondary', 'secondary-black', 'warning', 'danger', 'success', 'discount', 'leumi'];
